const responses = [
    { keywords: ['hello', 'hi', 'hey', 'yo'], reply: 'Hey there! 🌙 How can I help you with Floofcore today?' },
    { keywords: ['what is floofcore', 'floofcore', 'what can floofcore do'], reply: 'Floofcore is a modular, self-hostable Discord bot framework with AI-powered automation, cross-server systems, advanced moderation, economy, music, and more. It\'s built for communities of any size!' },
    { keywords: ['hosting', 'host', 'deploy', 'plans', 'moonmallow'], reply: 'MoonMallow Hosting offers 3 plans: Moonbeam ($4.99/mo), Starlight ($9.99/mo), and Galaxy ($19.99/mo). All include DDoS protection, 99.9% uptime, auto backups, and one-click deployment.' },
    { keywords: ['price', 'cost', 'pricing', 'how much', 'buy'], reply: 'Floofcore is $1.99 one-time (lifetime updates). Hosting starts at $4.99/mo. You can add items to your cart from the storefront!' },
    { keywords: ['self-host', 'self hosted', 'own server'], reply: 'Absolutely! You can self-host Floofcore on your own infrastructure. We give you the full bot code. Or use our cloud hosting for zero hassle.' },
    { keywords: ['support', 'help', 'contact', 'discord'], reply: 'Join our Discord community for support! All customers get access. Starlight+ plans get priority support with dedicated channels.' },
    { keywords: ['thank', 'thanks', 'thx', 'ty'], reply: 'You\'re welcome! ✨ Anything else I can help with?' },
    { keywords: ['bye', 'goodbye', 'see you'], reply: 'See you later! The Floofcore community awaits. ✨' },
];

const fallback = [
    'That\'s a great question! I\'m still learning, but you can check our FAQ section or join the Discord for more info.',
    'Hmm, I\'m not sure about that one. Try the FAQ or ask in our community Discord!',
    'I don\'t have an answer for that yet, but our team on Discord would love to help!',
];

export function initChatbot(container) {
    let open = false;
    const msgs = [{ role: 'bot', text: 'Hey! ✨ Ask me anything about Floofcore or hosting!', time: Date.now() }];

    const bubble = document.createElement('button');
    bubble.className = 'chat-bubble';
    bubble.innerHTML = '<span class="chat-bubble-icon">✦</span>';
    bubble.setAttribute('aria-label', 'Open chat');

    const win = document.createElement('div');
    win.className = 'chat-window';
    win.innerHTML = `
        <div class="chat-header">
            <span class="chat-header-icon">✦</span>
            <span class="chat-header-title">Floofcore AI</span>
            <button class="chat-close" aria-label="Close chat">✕</button>
        </div>
        <div class="chat-body" id="chatBody"></div>
        <div class="chat-input-wrap">
            <input type="text" class="chat-input" id="chatInput" placeholder="Ask something...">
            <button class="chat-send" id="chatSend" aria-label="Send">➤</button>
        </div>
    `;

    container.appendChild(bubble);
    container.appendChild(win);

    const chatBody = win.querySelector('#chatBody');
    const chatInput = win.querySelector('#chatInput');
    const chatSend = win.querySelector('#chatSend');
    const chatClose = win.querySelector('.chat-close');

    function render() {
        chatBody.innerHTML = msgs.map(m => `
            <div class="chat-msg ${m.role === 'bot' ? 'bot' : 'user'}">
                <div class="chat-msg-text">${m.text}</div>
                <div class="chat-msg-time">${new Date(m.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
            </div>
        `).join('');
        chatBody.scrollTop = chatBody.scrollHeight;
    }

    function getReply(input) {
        const lower = input.toLowerCase();
        for (const r of responses) {
            if (r.keywords.some(k => lower.includes(k))) return r.reply;
        }
        return fallback[Math.floor(Math.random() * fallback.length)];
    }

    function send() {
        const text = chatInput.value.trim();
        if (!text) return;
        msgs.push({ role: 'user', text, time: Date.now() });
        chatInput.value = '';
        render();

        const typing = document.createElement('div');
        typing.className = 'chat-msg bot typing';
        typing.innerHTML = '<div class="chat-msg-text"><span class="typing-dot"></span><span class="typing-dot"></span><span class="typing-dot"></span></div>';
        chatBody.appendChild(typing);
        chatBody.scrollTop = chatBody.scrollHeight;

        setTimeout(() => {
            typing.remove();
            msgs.push({ role: 'bot', text: getReply(text), time: Date.now() });
            render();
        }, 600 + Math.random() * 800);
    }

    bubble.addEventListener('click', () => {
        open = !open;
        win.classList.toggle('open', open);
        bubble.classList.toggle('open', open);
        if (open) render();
    });

    chatClose.addEventListener('click', () => {
        open = false;
        win.classList.remove('open');
        bubble.classList.remove('open');
    });

    chatSend.addEventListener('click', send);
    chatInput.addEventListener('keydown', e => {
        if (e.key === 'Enter') send();
    });

    render();
}
